import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setInputValidation, getInputData } from '../../store/forms';
import doValidations from './doValidations';
import creditCardNumberValidation from './creditCardNumberValidation';
import { allReserveSelector, ciRequired as ciRequiredSelector, licenseRequired as licenseRequiredSelector } from '../../store/reserve';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


const useCheckin2Validation = (saveValidation) => {
	const [valid, setValid] = useState(true);

	const view = "checkin2";
	const filesForm = "files";
	const cedulaAdelante = useSelector(getInputData(view, filesForm, "cedulaAdelante"));
	const cedulaPosterior = useSelector(getInputData(view, filesForm, "cedulaPosterior"));
	const licenciaAdelante = useSelector(getInputData(view, filesForm, "licenciaAdelante"));
	const licenciaPosterior = useSelector(getInputData(view, filesForm, "licenciaPosterior"));
	const birthday = useSelector(getInputData(view, filesForm, "birthday"));
	const driveLicenseExpiration = useSelector(getInputData(view, filesForm, "driveLicenseExpiration"));
	const identityCardExpiration = useSelector(getInputData(view, filesForm, "identityCardExpiration"));
	const warrantyForm = "warranty";
	const titularTarjeta = useSelector(getInputData(view, warrantyForm, "titularTarjeta"));
	const numeroTarjeta = useSelector(getInputData(view, warrantyForm, "numeroTarjeta"));
	const mesVencimiento = useSelector(getInputData(view, warrantyForm, "mesVencimiento"));
	const anoVencimiento = useSelector(getInputData(view, warrantyForm, "anoVencimiento"));
	const consentForm = "consent";
	const condiciones = useSelector(getInputData(view, consentForm, "condiciones"));
	const datosVeridicos = useSelector(getInputData(view, consentForm, "datosVeridicos"));
	const reserveData = useSelector(allReserveSelector);
	const { reserve: { trv_fec_dev} } = reserveData;
	const ciRequired = useSelector(ciRequiredSelector);
	const licenseRequired = useSelector(licenseRequiredSelector);
	const dispatch = useDispatch();
	const handleValidation = (id, valid, text, object) => {
		if (saveValidation) {
			dispatch(setInputValidation({ validation: { valid, text }, object, input: id, view }));	
		}
	};
	const notNullString = (string) => string !== '';
	const moreThan18Years = (date) => dayjs().diff(date, 'year') >= 18;
	const validExpiration = (date) => date >= dayjs(trv_fec_dev, "YYYY-MM-DD");
	const notToday = (date) => dayjs().format('YYYY-MM-DD') !== date.format('YYYY-MM-DD');
	const expiratedDocument = (obj) => {
		const fromCore = obj.source === 'core';
		const ciReq = ciRequired && obj.document === 'cedula';
		const licenseReq = licenseRequired && obj.document === 'licencia';
		return !(fromCore && (ciReq || licenseReq));
		
	};
	const [validFiles, setValidFiles] = useState(true);
	const fileValidations = [
		{
			id: 'cedulaAdelante',
			text: 'Adjunte una imagen',
			valid: () => notNullString(cedulaAdelante.data),
			document: 'cedula',
		},
		{
			id: 'cedulaAdelante',
			text: 'Documento expiró, adjunte una imagen',
			valid: () => expiratedDocument(cedulaAdelante),
			document: 'cedula',
		},
		{
			id: 'cedulaPosterior',
			text: 'Adjunte una imagen',
			valid: () => notNullString(cedulaPosterior.data),
			document: 'cedula',
		},
		{
			id: 'cedulaPosterior',
			text: 'Documento expiró, adjunte una imagen',
			valid: () => expiratedDocument(cedulaPosterior),
			document: 'cedula',
		},
		{
			id: 'licenciaAdelante',
			text: 'Adjunte una imagen',
			valid: () => notNullString(licenciaAdelante.data),
			document: 'licencia',
		},
		{
			id: 'licenciaAdelante',
			text: 'Documento expiró, adjunte una imagen',
			valid: () => expiratedDocument(licenciaAdelante),
			document: 'licencia',
		},
		{
			id: 'licenciaPosterior',
			text: 'Adjunte una imagen',
			valid: () => notNullString(licenciaPosterior.data),
			document: 'licencia',
		},
		{
			id: 'licenciaPosterior',
			text: 'Documento expiró, adjunte una imagen',
			valid: () => expiratedDocument(licenciaPosterior),
			document: 'licencia',
		},
		{
			id: 'birthday',
			text: 'Ingrese la fecha de nacimiento',
			valid: () => notToday(birthday.data),
			document: 'cedula',
		},
		{
			id: 'birthday',
			text: 'Debe ser mayor a 18 años',
			valid: () => moreThan18Years(birthday.data),
			document: 'cedula',
		},
		{
			id: 'driveLicenseExpiration',
			text: 'Ingrese la fecha de expiración de la licencia',
			valid: () => notToday(driveLicenseExpiration.data),
			document: 'licencia',
		},
		{
			id: 'driveLicenseExpiration',
			text: 'Licencia de conducir debe expirar después de la fecha de término de la reserva',
			valid: () => validExpiration(driveLicenseExpiration.data),
			document: 'licencia',
		},
		{
			id: 'identityCardExpiration',
			text: 'Ingrese la fecha de expiración de la cédula',
			valid: () => notToday(identityCardExpiration.data),
			document: 'cedula',
		},
		{
			id: 'identityCardExpiration',
			text: 'Cédula de identidad debe expirar después de la fecha de término de la reserva',
			valid: () => validExpiration(identityCardExpiration.data),
			document: 'cedula',
		}
	];
	useEffect(() => {
		const requiredValidations = fileValidations.filter((v)=> (v.document === 'cedula' && ciRequired) || (v.document === 'licencia' && licenseRequired));
		doValidations(requiredValidations, setValidFiles, (id, valid, text) => handleValidation(id, valid, text, 'files'));
	}, [cedulaAdelante.data, cedulaPosterior.data, licenciaAdelante.data, licenciaPosterior.data, driveLicenseExpiration.data, identityCardExpiration.data, birthday.data]); // eslint-disable-line react-hooks/exhaustive-deps
	const validations = [
		/*
		{
			id: 'titularTarjeta',
			text: 'Ingrese el nombre del titular de la tarjeta de crédito',
			valid: () => notNullString(titularTarjeta.data),
		},
		{
			id: 'numeroTarjeta',
			text: 'Ingrese el número de la tarjeta de crédito',
			valid: () => notNullString(numeroTarjeta.data),
		},
		*/
		{
			id: 'numeroTarjeta',
			text: 'El número de la tarjeta de crédito debe ser válido',
			valid: () => creditCardNumberValidation(numeroTarjeta.data) || numeroTarjeta.data === '',
		},
		/*
		{
			id: 'mesVencimiento',
			text: 'Seleccione un mes de expiración',
			valid: () => notNullString(mesVencimiento.data),
		},
		{
			id: 'anoVencimiento',
			text: 'Seleccione un año de expiración',
			valid: () => notNullString(anoVencimiento.data),
		},
		*/
	];
	useEffect(() => {
		doValidations(validations, setValid, (id, valid, text) => handleValidation(id, valid, text, 'warranty'));
	}, [titularTarjeta.data, numeroTarjeta.data, mesVencimiento.data, anoVencimiento.data]); // eslint-disable-line react-hooks/exhaustive-deps
	const [validConsent, setValidConsent] = useState(true);
	const consentValidations = [
		{
			id: 'condiciones',
			text: '',
			valid: () => condiciones.data,
		},
		{
			id: 'datosVeridicos',
			text: '',
			valid: () => datosVeridicos.data,
		},
	];
	useEffect(() => {
		doValidations(consentValidations, setValidConsent, (id, valid, text) => handleValidation(id, valid, text, 'consent'));
	}, [condiciones.data, datosVeridicos.data]); // eslint-disable-line react-hooks/exhaustive-deps
	return { valid,
		validConsent,
		validFiles,
	};
}

export default useCheckin2Validation;
